export const ngos = [
  {
    name: 'mimbo',
    visitLink: 'aboutus',
    donateLink:
      'https://fundahope.com/en/fundraisers/support-mimbos-mission-a-new-hope-for-strays',
  },
  {
    name: 'gmap',
    visitLink: 'https://givemeapawlb.org/',
    donateLink: 'https://givemeapawlb.org/donate/',
  },
  {
    name: 'animalslebanon',
    visitLink: 'https://www.animalslebanon.org/',
    donateLink: 'https://www.animalslebanon.org/donate',
  },
  {
    name: 'beta',
    visitLink: 'https://www.betalebanon.org/',
    donateLink: 'https://www.betalebanon.org/get-involved/donate/',
  },
  {
    name: 'apc',
    visitLink: 'https://apclebanon.org/',
    donateLink: 'https://apclebanon.org/donating/',
  },
  {
    name: 'carma',
    visitLink: 'https://www.instagram.com/carma_dog_shelter/?hl=en',
    donateLink: 'https://www.gofundme.com/f/urgent-need-or-lebanon-dogs-will-go-homeless',
  },
  {
    name: 'mashala',
    visitLink: 'https://www.instagram.com/mashalashelter/?hl=en',
    donateLink: 'https://www.gofundme.com/f/support-husseins-mission-to-rescue-animals',
  },
  {
    name: 'pawscrossed',
    visitLink: 'https://www.instagram.com/pawscrossedleb/',
    donateLink: 'https://fundahope.com/en/fundraisers/help-pawscrossed-family',
  },
  {
    name: 'rescuinginleb',
    visitLink: 'https://www.rescuinginlebanon.com/',
    donateLink: 'https://fundahope.com/en/fundraisers/help-me-help-the-animals-of-lebanon',
  },
  {
    name: 'lebanesewildlife',
    visitLink: 'https://www.instagram.com/lebanesewildlife/?hl=en',
    donateLink:
      'https://fundahope.com/en/fundraisers/lebanese-wildlife-rescue-and-rehabilitation-center?fbclid=PAZXh0bgNhZW0CMTEAAabZA-1AdAZxGSVP5AYyYh4XHLUguKxH-o7rN4zKe8h75yqO-uVSY6KW9pE_aem_-bNPODoEEdhLTNRyNnKIJg',
  },
  {
    name: 'doggosinleb',
    visitLink: 'https://www.instagram.com/doggosinleb/?hl=en',
    donateLink:
      'https://fundahope.com/en/fundraisers/help-save-abandoned-neglected-and-abused-dogs',
  },
  {
    name: 'bekaa',
    visitLink: 'https://www.bekaashelterlebanon.org/',
    donateLink: 'https://www.bekaashelterlebanon.org/donate',
  },
  {
    name: 'woofnwags',
    visitLink: 'https://www.woof-n-wags.com/',
    donateLink: 'https://www.woof-n-wags.com/donate',
  },
  {
    name: 'adopt',
    visitLink: 'https://adoptdontshoplb.org/',
    donateLink: 'https://fundahope.com/en/fundraisers/adopt-dont-shop-a-journey-of-love-hope',
  },
  {
    name: 'paris',
    visitLink: 'https://www.instagram.com/parisdogshelter_lb/',
    donateLink: 'https://www.gofundme.com/f/hope-for-the-voiceless-support-mireilles-animal-rescue',
  },
];
